import Alpine from "alpinejs";
import Cookies from "js-cookie";
import intersect from "@alpinejs/intersect";
import collapse from "@alpinejs/collapse";
import focus from "@alpinejs/focus";

import initGallery from "./components/gallery";
import initFitVids from "./components/fitvids";
import "./components/cookies";

window.Alpine = Alpine;
window.Cookies = Cookies;
Alpine.plugin(intersect);
Alpine.plugin(collapse);
Alpine.plugin(focus);
Alpine.start();

document.addEventListener("DOMContentLoaded", function (event) {
	document.querySelector("html").classList.remove("no-js");

	initGallery('.glide', {
		type: 'slider'
	});
	initFitVids('.prose');

});
